module.exports = __webpack_public_path__ + "assets/images/project/russia.jpg?v=9d047cbe";